export default __webpack_public_path__ + "static/media/newInvoiceArts.c7a77e75.png";